let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ebxtv")).then(() => parcelRequire('2WU7D'));